import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./store";
import WrappedApp from "WrappedApp";

const AppWithChecks = WrappedApp(App);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppWithChecks />
    </Provider>
    <ScrollToTop />
  </BrowserRouter>,
  document.getElementById("root")
);
